module.exports = __webpack_public_path__ + "static/media/v-down.bbe49c28.svg";